import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'
import * as _ from 'lodash'

Vue.use(VueResource)
Vue.use(Vuex)

// https://vuex.vuejs.org/guide/mutations.html

// Bump this whenever a fix requires stale persisted filter/context state to be cleared.
const STORE_VERSION = 2

export const store = new Vuex.Store({
    state: {
        // general state
        environment: null,
        currentUser: {},
        maskingUserStack: [], // last element is top of stack
        // filters
        userModel: null,
        userModelId: null,
        // persistent filters for data-table
        filters: {},
        contexts: {},
        storeVersion: STORE_VERSION,
        // help & intro messages
        helps: {},
        intros: {},
        // misc
        perPage: 10,
    },
    actions: {
        submit (context, payload) {
            context.commit(payload.mutation, payload.payload)
            localStorage.setItem('vuex', JSON.stringify(context.state))
        },
        initStore (context) {
            if (localStorage.getItem('vuex')) {
                const savedState = JSON.parse(localStorage.getItem('vuex'))
                // If the saved version doesn't match, discard stale filter/context state
                if (savedState.storeVersion !== STORE_VERSION) {
                    savedState.filters = {}
                    savedState.contexts = {}
                    savedState.storeVersion = STORE_VERSION
                }
                _.each(savedState, (value, key) => {
                    Vue.set(context.state, key, value)
                })
            }
        }
    },
    mutations: {
        initStore (state) {
            if (localStorage.getItem('vuex')) {
                const savedState = JSON.parse(localStorage.getItem('vuex'))
                // If the saved version doesn't match, discard stale filter/context state
                if (savedState.storeVersion !== STORE_VERSION) {
                    savedState.filters = {}
                    savedState.contexts = {}
                    savedState.storeVersion = STORE_VERSION
                }
                _.each(savedState, (value, key) => {
                    Vue.set(state, key, value)
                })
            }
        },
        environment (state, environment) {
            Vue.set(state, 'environment', environment)
        },
        currentUser (state, currentUser) {
            Vue.set(state, 'currentUser', currentUser)
        },
        maskingUserStack (state, maskingUserStack) {
            Vue.set(state, 'maskingUserStack', maskingUserStack)
        },
        userModel (state, userModel, userModelId) {
            Vue.set(state, 'userModel', userModel)
            Vue.set(state, 'userModelId', userModelId)
        },
        filters (state, { persistName, filters }) {
            state.filters[persistName] = filters
        },
        context (state, { persistName, context }) {
            state.contexts[persistName] = context;
        },
        helps (state, args) {
            if (args) {
                const tag = args.tag
                const text = args.text
                if (tag) {
                    let helps = state.helps || {}
                    helps[tag] = text
                    Vue.set(state, 'helps', helps)
                }
            }
        },
        clearHelps (state) {
            Vue.set(state, 'helps', {})
        },
        intros (state, args) {
            if (args) {
                const route = args.route
                const text = args.text
                if (route) {
                    let intros = state.intros || {}
                    intros[route] = text
                    Vue.set(state, 'intros', intros)
                }
            }
        },
        clearIntros (state) {
            Vue.set(state, 'intros', {})
        },
        clearFilters (state) {
            Vue.set(state, 'filters', {})
        },
        clearContexts(state) {
            Vue.set(state, 'contexts', {})
        },
        perPage(state, perPage) {
            Vue.set(state, 'perPage', perPage)
        },
    }
})
